import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/** Videos live on the competition detail page now. */
export default function CompetitionVideosPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/competitions/${id}#competition-videos`, { replace: true });
  }, [id, navigate]);

  return null;
}
